<template>
  <sw-modal :open="$attrs.open" @close="$emit('close')">
    <sw-panel class="modal-font">
      <span class="flex center font-modal-title">Choisissez la plus belle des polices</span>
      <div class="flex wrapper-font-form s-center">
        <div class="select-font-element">
          <select
            class="select-font"
            :style="previewFont"
            @change="selectFont"
            ref="fontFamilySelect"
          >
            <option
              v-for="(font, index) in fontList"
              :key="index"
              :style="font.style"
              :value="font.label"
              :selected="selectedFont.label === font.label"
            >{{font.label}}</option>
          </select>
        </div>

        <sw-button label="valider" @click="validFont" class="button-font-valid center full"/>
      </div>
    </sw-panel>
  </sw-modal>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'FontModal',
  components: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.selectedFont = { label: this.getFontFormat.label, fontFamily:this.getFontFormat.fontFamily, style: 'font-family:' + this.getFontFormat.fontFamily }
    this.fontList = this.getFontsList.map(item => {
      const ff = item.fontFamily ? item.fontFamily : item.label
      return { label: item.label, value: item, class: 'font-family-buttons center-y', style: `font-family: ${ff}, cursive;` }
    })
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      fontList: [],
      selectedFont: { label: 'Select font', fontFamily:'Roboto', style: 'font-family:Roboto;' }
    }
  },
  props: {},
  computed: {
    ...mapGetters(['getColorList','getFontsList', 'getCurrentColor', 'getFontFormat']),
    previewFont() {
      return this.selectedFont.style
    }
  },

  methods: {
    ...mapActions(['updateCurrentColor']),
    selectFont(evt) {
      const fontLabel = evt.target.selectedOptions[0].label
      const fontItem = this.getFontsList.find(fontItem => fontItem.label === fontLabel)
      const fontFamily = fontItem.fontFamily ? fontItem.fontFamily : fontLabel
      this.selectedFont = { label: fontLabel, fontFamily, style: 'font-family:' + fontFamily + ', cursive;' }
    },
    validFont() {
      this.$emit('selectFont', this.selectedFont.fontFamily)
    }
  },
  watch: {}
}
</script>






// WEBPACK FOOTER //
// src/components/modal/FontModal.vue